import { BudgetSummaryTable } from "./budget-summary-table";

interface BudgetMechanism {
  name: string;
  approvedValue: number;
  capturedValue: number;
  balance: number;
}

interface ProjectBudgetContentProps {
  name: string;
  salicNumber: string;
  proponent: string;
  cnpj: string;
  logline: string;
  budgetMechanisms: BudgetMechanism[];
}

export function ProjectBudgetContent({
  name,
  salicNumber,
  proponent,
  cnpj,
  logline,
  budgetMechanisms,
}: ProjectBudgetContentProps) {
  return (
    <div className="flex flex-col gap-[30px] items-start w-full">
      {/* Project Title Section */}
      <div className="flex flex-col gap-[10px] items-start w-full">
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[24px] w-[989px]">
          Orçamentos do Projeto - {name}
        </p>
        <div className="flex gap-[10px] items-start font-['Plus_Jakarta_Sans'] font-normal text-[#d1d1d1] text-[14px] leading-[0] whitespace-pre w-full">
          <p className="leading-normal">
            <span>Número Salic: </span>
            <span className="font-semibold text-[#f6f6f6]">{salicNumber}</span>
          </p>
          <p className="leading-normal">
            <span>Produtora: </span>
            <span className="font-semibold text-[#f6f6f6]">
              {proponent} | {cnpj}
            </span>
          </p>
        </div>
        <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#f6f6f6] text-[14px] w-full">
          {logline}
        </p>
      </div>

      {/* Horizontal Divider */}
      <div className="h-[1px] w-full bg-[#888888]/20" />

      {/* Budget Summary Section */}
      <div className="flex flex-col gap-[35px] items-start w-full">
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] w-full">
          Resumo geral de orçamento
        </p>

        <BudgetSummaryTable mechanisms={budgetMechanisms} />
      </div>
    </div>
  );
}
